<template>
  <!-- Keyed by domain: the panel reads its domain once, on creation. -->
  <manage-authentication-view :key="domain" :for-domain="domain" />
</template>

<script>
import ManageAuthenticationView from '@/views/services/hosting/shared/email/ManageAuthenticationView'

/**
 * DKIM and SPF of the domain this account is opened on — the main domain or
 * an addon domain (AM-1108). The hosting section's per-domain panel, shown
 * straight away rather than behind a list of every domain on the service.
 */
export default {
  name: 'AccountDomainSettingsView',
  components: { ManageAuthenticationView },
  // Passed down by EmailAccountView, which has already pointed the hosting
  // context at this account's service.
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // vue-router has already decoded this.
    domain () {
      return this.$route.params.maindomain
    },
  },
}
</script>
